import { CONSTANTS, NumberUtils } from '@pk/powerkioskutils';

export class ViewRfqSessionProductBid {
	public rfqSessionBidId: string;
	public rfqSessionId: string;
	public rfqSessionSupplierId: string;
	public rfqSessionProductId: string;
	public addDate: Date;
	public isOnHold: boolean;
	public originalBid: number;
	public packingMargin: number;
	public shortTermPackingMargin: number;
	public packedMargin: number;
	public addedNetRevenue: number;
	public effectivePrice: number;
	public supplierId: string;
	public supplierName: string;
	public isLatestBid: boolean;
	public todayBidRank: number;
	public todaySupplierProductTotalBids: number;
	public serviceTypeId: string;
	public currencySymbol: string;
	public annualUsage: number;
	public term: number;

	public displayOriginalBid: number;
	public displayEffectivePrice: number;
	public displayPackedMargin: number;
	public displayBidUnits: string;
	public displayShortTermPackingMargin: number;

	constructor(bid?: ViewRfqSessionProductBid) {
		Object.assign(this, bid);

		if (this.serviceTypeId) {
			this.displayBidUnits = this.serviceTypeId === CONSTANTS.serviceTypes.naturalGas.serviceTypeId ? 'dth' : 'MWh';
			if (this.originalBid) {
				this.displayOriginalBid = NumberUtils.rateToUnits(this.originalBid, this.displayBidUnits.toLowerCase());
			}
			if (this.effectivePrice) {
				this.displayEffectivePrice = NumberUtils.rateToUnits(this.effectivePrice, this.displayBidUnits.toLowerCase());
			}
			if (this.packedMargin) {
				this.displayPackedMargin = NumberUtils.rateToUnits(this.packedMargin, this.displayBidUnits.toLowerCase());
			}
			if (this.shortTermPackingMargin) {
				this.displayShortTermPackingMargin = NumberUtils.rateToUnits(this.shortTermPackingMargin, this.displayBidUnits.toLowerCase());
			}
		}
	}
}
